export default "__VITE_ASSET__DohnsGfE__"